(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adultsuper-brand-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-directory')) {
    customElements.define('brand-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const input = this.querySelector('[data-brand-filter]');
        const items = [...this.querySelectorAll('[data-brand-name]')];
        const normalize = (value) => value.toLocaleLowerCase().replace(/[^a-z0-9]/g, '');
        input.addEventListener('input', () => {
          const query = normalize(input.value.trim());
          let count = 0;
          items.forEach((item) => {
            const matches = normalize(item.dataset.brandName).includes(query);
            item.hidden = !matches;
            if (matches) count += 1;
          });
          this.querySelectorAll('[data-brand-group]').forEach((group) => {
            const visible = !!group.querySelector('[data-brand-name]:not([hidden])');
            group.hidden = !visible;
            this.querySelector('[data-letter="' + group.dataset.brandGroup + '"]').hidden = !visible;
          });
          this.querySelector('[data-brand-status]').textContent = count + ' ' + (count === 1 ? this.dataset.singular : this.dataset.plural);
          this.querySelector('[data-brand-empty]').hidden = count !== 0;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adultsuper-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-as-special-popup]').forEach((popup) => {
    const key = 'as-special-seen-' + popup.dataset.promoKey;
    let seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch {}
    if (seen || typeof popup.showModal !== 'function' || Shopify.designMode) return;
    let previousFocus;
    const close = () => popup.close();
    popup.querySelector('.as-special-popup__close').addEventListener('click', close);
    popup.querySelector('.as-special-popup__dismiss').addEventListener('click', close);
    popup.addEventListener('click', (event) => { if (event.target === popup) { const rect = popup.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
    popup.addEventListener('close', () => { if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true }); });
    const show = () => {
      if (!popup.isConnected) return;
      if (document.hidden || Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((modal) => modal.getClientRects().length > 0 && getComputedStyle(modal).visibility !== "hidden" && (!modal.closest("details") || modal.closest("details").open))) { window.setTimeout(show, 2000); return; }
      previousFocus = document.activeElement;
      popup.showModal();
      try { sessionStorage.setItem(key, '1'); } catch {}
    };
    window.setTimeout(show, 6000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
